import enTesting from './en';
import ruTesting from './ru';

export default {
  en: {
    ...enTesting,
  },
  ru: {
    ...ruTesting,
  },
};
